export default function setupMobileMenu() {
    const header = document.querySelector('[data-site-header]');
    const navOverlay = document.getElementById('site-menu');
    const toggles = document.querySelectorAll('[data-toggle-mobile-menu]');
    const navLinks = navOverlay?.querySelectorAll('a[href]');
    const mobileViewport = window.matchMedia('(max-width: 1023px)');

    if (!header || !navOverlay || !toggles.length) {
        return;
    }

    function isOpen() {
        return document.body.classList.contains('mobile-menu-is-active');
    }

    function syncScrollbarCompensation() {
        if (window.CSS?.supports?.('scrollbar-gutter: stable')) {
            document.documentElement.style.setProperty('--scrollbar-compensation', '0px');
            return;
        }

        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbar-compensation', `${Math.max(scrollbarWidth, 0)}px`);
    }

    function syncOffset() {
        const alertBannerHeight = Array.from(document.querySelectorAll('[data-alert-banner]'))
            .reduce((height, banner) => height + banner.getBoundingClientRect().height, 0);
        const headerHeight = header.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--mobile-nav-offset', `${headerHeight + alertBannerHeight}px`);
    }

    function syncState(open) {
        syncScrollbarCompensation();
        syncOffset();
        document.body.classList.toggle('mobile-menu-is-active', open);
        header.classList.toggle('header--menu-open', open);
        navOverlay.setAttribute('aria-hidden', String(!open));
        navOverlay.toggleAttribute('inert', !open);
        toggles.forEach((toggle) => {
            toggle.setAttribute('aria-expanded', String(open));
            toggle.classList.toggle('is-active', open);
        });
    }

    function closeMenu() {
        syncState(false);
    }

    function toggleMenu() {
        if (!mobileViewport.matches) {
            return;
        }

        syncState(!isOpen());
    }

    syncScrollbarCompensation();
    syncOffset();

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', toggleMenu);
    });

    navOverlay.addEventListener('click', (event) => {
        if (event.target === navOverlay) {
            closeMenu();
        }
    });

    navLinks?.forEach((link) => {
        link.addEventListener('click', () => {
            closeMenu();
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen()) {
            closeMenu();
            toggles[0]?.focus();
        }
    });

    mobileViewport.addEventListener('change', (event) => {
        if (!event.matches) {
            closeMenu();
        }

        syncScrollbarCompensation();
        syncOffset();
    });

    window.addEventListener('resize', () => {
        syncScrollbarCompensation();
        syncOffset();
    });

    window.addEventListener('alert-banner:updated', syncOffset);

    if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(syncOffset);
        resizeObserver.observe(header);
        document.querySelectorAll('[data-alert-banner]').forEach((banner) => {
            resizeObserver.observe(banner);
        });
    }
}
